import React, { useState, useEffect } from "react";
import { useAuth, useNavigate } from "../../../context/AuthContext";
  import { useLocation } from "react-router-dom";

import "../../account/ReferralSection.css";

const ReferralSection = ({ setStatusModal }) => {
  const { user } = useAuth();
  
  const referralCode = user?.referralCode || user?._id;
  const referralLink = `https://tutorslinks.com/ref/${referralCode}`;

  // ✅ Copy link
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(referralLink);

      setStatusModal({
        open: true,
        type: "success",
        message: "Copied!",
        subtext: "Referral link copied to clipboard.",
      });
    } catch (err) {
      console.error(err);
    }
  };

  // ✅ Native share (mobile + supported browsers)
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Join TutorsLinks",
          text: "Sign up using my referral link and get started!",
          url: referralLink,
        });
      } catch (err) {
        console.error("Share cancelled or failed", err);
      }
    } else {
      // fallback
      handleCopy();
    }
  };

  return (
    <div className="referral-container">
      <h3>Refer a Friend</h3>
      <p>Invite friends and earn rewards when they join.</p>

      <div className="referral-box">
        <input
          type="text"
          value={referralLink}
          readOnly
          className="referral-input"
        />

        <button className="copy-btn" onClick={handleCopy}>
          Copy Link
        </button>

        <button className="share-btn" onClick={handleShare}>
          Share
        </button>

        <a
          href={`https://wa.me/?text=${encodeURIComponent(
            `Join TutorsLinks using my link: ${referralLink}`,
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-btn"
        >
          WhatsApp
        </a>
      </div>

      <small className="referral-note">
        Share your link via WhatsApp, Facebook, Email and more.
      </small>
    </div>
  );
};

export default ReferralSection;
